<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标识">
            <a-input v-model="searchForm.slug" allowClear placeholder="请输入标识" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select v-model="searchForm.line_id" allowClear show-search option-filter-prop="children" placeholder="请选择发布平台" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{ item.org }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="平台分类">
            <a-select v-model="searchForm.platform_class" allowClear show-search option-filter-prop="children" placeholder="请选择平台分类" style="width: 100%">
              <a-select-option v-for="item in PICTURES_PLATFORM_CLASS" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="类型">
            <a-select v-model="searchForm.class" allowClear show-search option-filter-prop="children" placeholder="请选择类型" style="width: 100%">
              <a-select-option v-for="item in PICTURES_CLASS_TYPE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.state" allowClear show-search option-filter-prop="children" placeholder="请选择状态" style="width: 100%">
              <a-select-option v-for="item in PICTURES_STATE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="起止时间">
            <v-range-picker v-model="times" :placeholder="['开始时间', '结束时间']" :isDate="true"/>
          </a-form-item>
        </a-col>
        <!-- <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="APP类型">
            <a-select v-model="searchForm.picture_type" allowClear show-search option-filter-prop="children" placeholder="请选择类型" style="width: 100%">
              <a-select-option v-for="item in PICTURES_PICTURE_TYPE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="$router.push('/picture/edit')">添加图片</a-button>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right:10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table size="middle" row-key="id" :columns="columns" :loading="loading" :data-source="data" :scroll="{ x: 1500 }" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
      <span slot="slug">
        标识
        <a-tooltip>
          <template slot="title">
            当【发布平台>平台分类>类型】无法准确定位具体图片位置时，可通过 “标识” 辅助定位
          </template>
          <img src="/wenhaofill.png" alt="icon" style="width: 18px;height: 18px;vertical-align: -4px;">
        </a-tooltip>
      </span>
      <template slot="sort" slot-scope="text, record">
        <a-input-number v-model="record.sort" :min="0" @blur="inputDebounce(text, record)" style="width:50px;" />
      </template>
      <template slot="org" slot-scope="text">
        <a-tag color="blue">{{ text }}</a-tag>
      </template>
      <template slot="path" slot-scope="text">
        <div class="pre-img">
          <img :src="text" @click="handlePreview(text)">
        </div>
      </template>
      <template slot="demo_picture" slot-scope="text">
        <a-button type="link" @click="handlePreview(text)" v-if="text">查看</a-button>
        <span v-else>/</span>
      </template>
      <template slot="link_url" slot-scope="text">
        <a :href="text" target="_blank" class="literalExplan" :title="text">{{ text }}</a>
      </template>
      <template slot="literal_explan" slot-scope="text">
        <div class="literalExplan" :title="text">{{ text || '/' }}</div>
      </template>
      <template slot="state" slot-scope="text,record">
        <div v-if="text === 1" style="color:green">启用
          <div style="color:#999999;">{{ parseStauts(record) }}</div>
        </div>
        <div v-else style="color:red;">禁用</div>
      </template>
      <template slot="start_end_times" slot-scope="text, record">
        <p style="margin-bottom: 0">起: {{ record.start_at | parseTime }}</p>
        <p style="margin-bottom: 0">止: {{ record.end_at | parseTime }}</p>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a-dropdown>
          <span class="ant-dropdown-link">
            更多操作
            <a-icon type="down" />
          </span>
          <a-menu slot="overlay" @click="handleTableCommand($event, record)">
            <a-menu-item class="ant-dropdown-link" key="editPicPath">修改图片路径</a-menu-item>
            <a-menu-item class="ant-dropdown-link" key="addParams">增加参数</a-menu-item>
            <a-menu-item class="ant-dropdown-link" key="forbid">{{ record.state == 1 ? '禁用' : '启用' }}</a-menu-item>
            <a-menu-item class="ant-dropdown-link" key="edit">编辑</a-menu-item>
            <a-menu-item class="ant-dropdown-link" key="delete">删除</a-menu-item>
            <!-- <a-menu-item key="sort">修改排序</a-menu-item> -->
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
    <!-- 图片预览 -->
    <a-modal width="40%" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <!-- 修改排序 -->
    <a-modal width="40%" title="修改排序" :visible="sortVisible" @cancel="sortVisible = false" @ok="handleTableCommand('sortSure')">
      <a-input-number v-model="sortVal" placeholder="请输入" />
    </a-modal>
    <!-- 修改路径 -->
    <a-modal width="40%" title="修改路径" :visible="pathVisible" @cancel="pathVisible = false" @ok="handleTableCommand('editPicPathSure')">
      <a-textarea v-model="pathVal" placeholder="请输入" />
    </a-modal>
    <!-- 编辑参数 -->
    <a-modal width="50%" title="编辑参数" :visible="paramsVisible" @cancel="paramsVisible = false" @ok="handleTableCommand('addParamsSure')">
      <template v-for="(item, key) in params">
        <div class="flex-sb" :key="key" style="margin-bottom: 10px">
          <a-input v-model="item.name" style="width: 40%" placeholder="请输入" />
          <a-input v-model="item.value" style="width: 40%" placeholder="请输入" />
          <a-button @click="handleParams(key)">{{ key ? '删除' : '添加' }}</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns } from './business/pictureList'
import { strategyCommand } from './business/form'
import pagination from '@/composables/pagination'
import compuedFun from './computed/'
import moment from 'moment'
import api from '@/api/'

export default {
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      sortVal: 0, // 排序值
      pathVal: 0, // 路径值
      params: [{ name: '', value: '' }], // 参数值
      times: [],
      platformList: [],
      previewImage: '', // 图片预览
      sortVisible: false, // 排序
      pathVisible: false, // 路径
      paramsVisible: false, // 编辑参数
      previewVisible: false, // 图片预览
      searchForm: JSON.parse(JSON.stringify(searchForm))
    })

    onMounted(async () => {
      state.searchForm = _this.SEARCH_FORM
      state.times = _this.SEARCH_FORMDAY
      await methods.getList()
      methods.getPlatform()
    })

    onUnmounted(async () => {
      if (!_this.$route.params.id) {
        _this.SET_SEARCH[0]({})
        _this.SET_SEARCHDAY[0]([])
      }
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        _this.SET_SEARCHDAY[0](state.times)
        _this.SET_SEARCH[0](state.searchForm)
        this.getList()
      },

      async getList() {
        _this.loading = true
        state.searchForm.start_time = state.times[0]
        state.searchForm.end_time = state.times[1]
        const res = await api.listPicture({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        // const { pictures, pagination } = res?.data
        const pictures = res?.data?.pictures || []
        const pagination = res?.data?.pagination || _this.pagination
        _this.data = pictures
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },

      async inputDebounce(sort, data) {
        const res = await api.sortPicture(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },

      // 增减参数列表
      handleParams(key) {
        if (!key) return state.params.push({ name: '', value: '' })
        state.params.splice(key, 1)
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        type = typeof type === 'object' ? type.key : type
        strategyCommand[type].call(_this, ...arg)
      },

      handlePreview(url) {
        state.previewImage = url
        state.previewVisible = true
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },
      parseStauts(row) {
        const time = moment().unix()
        const text = time >= row.end_at ? '已过期' : time >= row.start_at ? '生效中' : '待生效'
        return text
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods
    }
  }
}
</script>
<style lang='less'>
.pre-img {
  width: 150px;
  height: 50px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
}
.literalExplan{
  text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	-webkit-box-orient: vertical;
  width: 100px;
}
</style>
